
function $parcel$defineInteropFlag(a) {
  Object.defineProperty(a, '__esModule', {value: true, configurable: true});
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("g9F2R", function(module, exports) {

$parcel$defineInteropFlag(module.exports);
$parcel$export(module.exports, "default", () => $a6bf34bc34139114$export$2e2bcd8739ae039);
/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ //English (United Kingdom)
var $a6bf34bc34139114$export$2e2bcd8739ae039 = {
    'project-create.create-project-heading.back-button': 'Go back',
    'project-create.create-project-heading.header': 'Create project',
    'project-create.error.description': 'Something went wrong, please check your internet connection and try again.',
    'project-create.error.header': 'Could not create project',
    'project-create.project-create-footer.cancel-button': 'Cancel',
    'project-create.project-create-footer.create-button': 'Create',
    'project-create.project-create-icon.label': 'Choose an emoji',
    'project-create.project-create-icon.picker-tooltip': 'Change Emoji',
    'project-create.project-create-name.error': 'You must provide a project name',
    'project-create.project-create-name.label': 'Name',
    'project-create.project-create-private.description': 'Only contributors or people you share with can view a private project.',
    'project-create.project-create-private.label': 'Privacy controls',
    'project-create.project-create-private.toggle': 'Make private',
    'project-create.required-fields-are-marked': 'Required fields are marked with an asterisk<asterisk></asterisk>'
};

});


//# sourceMappingURL=en_GB.702092de.js.map
